module.exports = __webpack_public_path__ + "img/course_bg4.e83cccb1.png";